import { useEffect, useContext, useState } from "react";
import { post, remove } from "../../../../adapters/xhr/api";
import Modal from "react-modal";
import stylesModal from "./Modal.module.css";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import FieldRenderer from "../common/FieldRendrer";
import { validateRequired } from "../../../../helpers/Validation";
import { getExploitationTypes } from "../../../../adapters/apis/lookups/lookups";
import { useParams, useLocation } from "react-router-dom";

const VacantLandForm = ({
  generateOptions,
  govs,
  residentialUnitTypes,
  error_new_user,
  setValidFields,
  handleChangeDeclerationUnit,
  landOwnershipLegalDocument,
  leaseContractFileInputRef,
  setUploadFileError,
  setError,
  fileInputKeys,
  DownloadFile,
  handlePreviewFile,
  doYouWantExtraAttachments,
  setBackendError,
  setSubmissionError,
  setTempFiles,
}) => {
  Modal.setAppElement("body");
  const { id } = useParams();
  const location = useLocation();
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const { declarationRequest, updateDeclarationUnit } =
    unifiedTaxDeclarationContext;

  const [exploitationTypes, setExploitationTypes] = useState([]);
  const [fileErrors, setFileErrors] = useState({});
  // Vacant lands state
  const [currentVacantLand, setCurrentVacantLand] = useState({
    id: Math.random(),
    used_land_area: "",
    exploitation_type_id: "",
    exploitation_type_other: "",
    reta_contact_about_unit: "",
    account_code: "",
    market_value: "",
  });

  const [vacantLandErrors, setVacantLandErrors] = useState({
    used_land_area: "",
    exploitation_type_id: "",
    exploitation_type_other: "",
    reta_contact_about_unit: "",
    account_code: "",
  });

  const [addVacantLandErrorMessage, setAddVacantLandErrorMessage] =
    useState("");
  const [showModal, setShowModal] = useState(false);
  const [isAddVacantButtonDisabled, setIsAddVacantButtonDisabled] =
    useState(false);
  const [vacantLandToDelete, setVacantLandToDelete] = useState(null);
  const [vacantLandIndexToDelete, setVacantLandIndexToDelete] = useState(null);
  const [editingVacantLandIndex, setEditingVacantLandIndex] = useState(null);
  const hasUnitAddress = declarationRequest?.unit?.buildingProfile?.renin;

  // Load exploitation types
  useEffect(() => {
    const loadLookups = async () => {
      try {
        const res = await getExploitationTypes();
        const data = res?.data?.data;
        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.exploitation_types)
            ? data.exploitation_types
            : [];

        setExploitationTypes(list);
      } catch (error) {
        console.error("Error loading exploitation types:", error);
      }
    };
    loadLookups();
  }, []);

  const resolveExploitationLabel = (exploitationId) => {
    const exploitationItem = (exploitationTypes || []).find(
      (exploitation) => String(exploitation?.id) === String(exploitationId),
    );
    return (
      exploitationItem?.name || exploitationItem?.other || exploitationItem
    );
  };

  const formFields = ({
    declarationRequest,
    error_new_user,
    handleChangeDeclerationUnit,
    stylesRequestData,
  }) => [
    {
      type: "input",
      colClass: "col-md-4",
      name: "total_land_area",
      labelText: "مساحة الأرض الكلية ",
      placeholder: "ادخل مساحة الأرض الكلية..",
      labelHtmlFor: "total_land_area",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.total_land_area || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.total_land_area,
      stylesRequestData,
      required: true,
    },
  ];

  const fields = formFields({
    declarationRequest,
    error_new_user,
    residentialUnitTypes,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
  });

  const handleChangeUnitFile = async (pc, c, key, value, i, bi, fi, ref) => {
    try {
      const labelMap = {
        land_ownership_legal_document: "ownership_deed",
        land_lease_agreement: "lease_contract",
      };
      const label = labelMap[key] || key;
      const data = new FormData();
      data.append("label", label);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        updateDeclarationUnit(key, response?.data?.data);
        setError(key, "");
        setUploadFileError(null);
        setFileErrors((prev) => ({ ...prev, [key]: "" }));
        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        updateDeclarationUnit(key, null);
        window.scrollTo(0, 0);
        // setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
        setFileErrors((prev) => ({
          ...prev,
          [key]: error?.response?.data?.errors?.file?.[0] || "خطأ في الملف",
        }));
        if (ref?.current) {
          ref.current.value = null;
        }
      }
    }
  };

  // Add vacant land handler
  const handleAddVacantLand = async () => {
    setBackendError(null);
    setIsAddVacantButtonDisabled(false);
    // Validate required fields
    let hasErrors = false;
    const errors = {
      used_land_area: "",
      exploitation_type_id: "",
      reta_contact_about_unit: "",
      exploitation_type_other: "",
    };

    const totalLandAreaRaw = declarationRequest?.unit?.total_land_area;
    const totalLandArea = parseFloat(totalLandAreaRaw);

    if (!validateRequired(totalLandAreaRaw)) {
      setError("total_land_area", "مساحة الأرض الكلية مطلوبة");
      setValidFields((prev) => ({
        ...prev,
        total_land_area: false,
      }));
      hasErrors = true;
    } else {
      setError("total_land_area", "");
      setValidFields((prev) => ({
        ...prev,
        total_land_area: true,
      }));
    }

    if (!validateRequired(currentVacantLand.used_land_area)) {
      errors.used_land_area = "يجب ادخال مساحة";
      hasErrors = true;
    }

    const usedLandArea = parseFloat(currentVacantLand.used_land_area);
    if (
      validateRequired(currentVacantLand.used_land_area) &&
      !Number.isNaN(usedLandArea) &&
      !Number.isNaN(totalLandArea) &&
      usedLandArea > totalLandArea
    ) {
      errors.used_land_area =
        "يجب أن تكون المساحة الكلية أكبر من مجموع المساحات المستغلة المُدخلة أو مساوية لها";
      hasErrors = true;
    }

    if (!validateRequired(currentVacantLand.exploitation_type_id)) {
      errors.exploitation_type_id = "يجب اختيار نوع الإستغلال";
      hasErrors = true;
    }

    if (!validateRequired(currentVacantLand.reta_contact_about_unit)) {
      errors.reta_contact_about_unit = "يجب اختيار إجابة";
      hasErrors = true;
    }

    if (
      currentVacantLand.account_code &&
      !/^\d{14}$/.test(String(currentVacantLand.account_code))
    ) {
      errors.account_code = "كود حساب الوحدة يجب أن يكون 14 رقمًا";
      hasErrors = true;
    }

    const exploitationTypeOtherPattern =
      /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_.\\/,\s]{1,100}$/;

    const isOtherExploitationType =
      parseInt(currentVacantLand.exploitation_type_id) === 7;

    if (isOtherExploitationType) {
      if (!validateRequired(currentVacantLand.exploitation_type_other)) {
        errors.exploitation_type_other = "يجب ادخال نوع الإستغلال الآخر";
        hasErrors = true;
      } else if (
        !exploitationTypeOtherPattern.test(
          currentVacantLand.exploitation_type_other.trim(),
        )
      ) {
        errors.exploitation_type_other =
          "نوع الاستغلال الآخر يحتوي على رموز غير مسموحة";
        hasErrors = true;
      }
    }

    if (hasErrors) {
      setVacantLandErrors(errors);
      // setAddVacantLandErrorMessage("يرجى ملء جميع الحقول المطلوبة");
      return;
    }

    // Add vacant land to array
    const normalizedVacantLand = (() => {
      const retaContactAboutUnit = Number.parseInt(
        currentVacantLand.reta_contact_about_unit,
        10,
      );

      const base = {
        id: currentVacantLand.id || Math.random(),
        used_land_area: currentVacantLand.used_land_area,
        exploitation_type_id: currentVacantLand.exploitation_type_id,
        exploitation_type_other: "",
        reta_contact_about_unit: retaContactAboutUnit,
        account_code:
          retaContactAboutUnit === 1 ? currentVacantLand.account_code : "",
        market_value: currentVacantLand.market_value,
        is_edit: editingVacantLandIndex !== null,
      };

      if (parseInt(currentVacantLand.exploitation_type_id) !== 7) {
        return base;
      }

      return {
        ...base,
        exploitation_type_other:
          currentVacantLand.exploitation_type_other.trim(),
      };
    })();

    const existingVacantLands = declarationRequest?.unit?.vacantLands || [];

    let newVacantLands;
    if (
      editingVacantLandIndex !== null &&
      editingVacantLandIndex >= 0 &&
      editingVacantLandIndex < existingVacantLands.length
    ) {
      newVacantLands = existingVacantLands.map((vacantLand, idx) =>
        idx === editingVacantLandIndex
          ? {
              ...normalizedVacantLand,
              id: normalizedVacantLand.id ?? vacantLand?.id,
              is_edit: true,
            }
          : {
              ...vacantLand,
              is_edit: false,
            },
      );
    } else {
      newVacantLands = [
        ...existingVacantLands.map((vacantLand) => ({
          ...vacantLand,
          is_edit: false,
        })),
        {
          ...normalizedVacantLand,
          is_edit: false,
        },
      ];
    }

    if (declarationRequest?.unit?.id) {
      try {
        let url = `api/declaration-system/declarations/${id}/vacant/${declarationRequest?.unit?.id}`;

        const newVacantLand = { ...normalizedVacantLand };
        if (newVacantLand.id < 1) {
          delete newVacantLand.id;
        }
        delete newVacantLand.is_edit;
        newVacantLand.total_land_area =
          declarationRequest?.unit?.total_land_area;
        newVacantLand.total_used_area =
          declarationRequest?.unit?.total_used_area;

        const data = {
          building: newVacantLand,
        };
        const response = await post(
          url,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
          data,
        );
        updateDeclarationUnit(
          "vacantLands",
          response?.data?.unit?.vacant_lands,
        );
      } catch (error) {
        if (error.response?.data?.errors) {
          setSubmissionError(error.response?.data?.errors);
        } else {
          setBackendError(
            error.response?.data?.message ||
              error.response?.data?.data?.message ||
              "خطأ في إرسال البيانات",
          );
        }

        window.scrollTo(0, 0);
      }
    } else {
      updateDeclarationUnit("vacantLands", newVacantLands);
    }

    // Reset form
    setCurrentVacantLand({
      // id: Math.random(),
      used_land_area: "",
      exploitation_type_id: "",
      exploitation_type_other: "",
      reta_contact_about_unit: "",
      account_code: "",
      market_value: "",
    });
    setVacantLandErrors({
      used_land_area: "",
      exploitation_type_id: "",
      exploitation_type_other: "",
      reta_contact_about_unit: "",
      account_code: "",
    });
    setEditingVacantLandIndex(null);
    setAddVacantLandErrorMessage("");
  };

  useEffect(() => {
    if (
      (declarationRequest?.unit?.vacantLands ?? []).reduce(
        (s, x) =>
          String(x?.id) === String(currentVacantLand?.id)
            ? s
            : s + parseFloat(x?.used_land_area || 0),
        0,
      ) +
        parseFloat(currentVacantLand.used_land_area || 0) >
      parseFloat(declarationRequest?.unit?.total_land_area || 0)
    ) {
      setIsAddVacantButtonDisabled(true);
      if (currentVacantLand.used_land_area) {
        setVacantLandErrors({
          used_land_area:
            "يجب أن تكون المساحة الكلية أكبر من مجموع المساحات المستغلة المُدخلة أو مساوية لها",
        });
        setError("total_land_area", "");
      } else {
        setError(
          "total_land_area",
          "يجب أن تكون المساحة الكلية أكبر من مجموع المساحات المستغلة المُدخلة أو مساوية لها",
        );
      }
    } else {
      setIsAddVacantButtonDisabled(false);
      if (currentVacantLand.used_land_area) {
        setVacantLandErrors({
          used_land_area: "",
        });
      }

      setError("total_land_area", "");
    }
  }, [
    declarationRequest?.unit?.total_land_area,
    currentVacantLand.used_land_area,
  ]);

  // Remove vacant land handler
  const handleRemoveVacantLand = async (landToDelete, index) => {
    const isUpdateMode =
      declarationRequest?.editMode || declarationRequest?.isUnitEditMode;
    const declarationId = declarationRequest?.id;
    const vacantLandUnitId = declarationRequest?.unit?.id;
    const vacantLandExploitationUnitId = landToDelete?.id;

    if (
      isUpdateMode &&
      declarationId &&
      vacantLandUnitId &&
      vacantLandExploitationUnitId &&
      Number(vacantLandExploitationUnitId) >= 1
    ) {
      try {
        const url = `api/declaration-system/declarations/${declarationId}/units/vacant/${vacantLandUnitId}/vacant_unit/${vacantLandExploitationUnitId}`;
        await remove(url, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
      } catch (error) {
        setBackendError(
          error.response?.data?.message ||
            error.response?.data?.data?.message ||
            "خطأ في إرسال البيانات",
        );
        closeDeleteVacantLandModal();
        setAddVacantLandErrorMessage("تعذر حذف الاستغلال، حاول مرة أخرى");
        window.scrollTo(0, 0);
        return false;
      }
    }

    const updated = (declarationRequest?.unit?.vacantLands || []).filter(
      (_, idx) => idx !== index,
    );
    updateDeclarationUnit("vacantLands", updated);

    if (editingVacantLandIndex === index) {
      setEditingVacantLandIndex(null);
      setCurrentVacantLand({
        used_land_area: "",
        exploitation_type_id: "",
        exploitation_type_other: "",
        reta_contact_about_unit: "",
        account_code: "",
        market_value: "",
      });
    }

    setAddVacantLandErrorMessage("");
    return true;
  };

  const openDeleteVacantLandModal = (landToDelete, index) => {
    setVacantLandToDelete(landToDelete);
    setVacantLandIndexToDelete(index);
    setShowModal(true);
  };

  const closeDeleteVacantLandModal = () => {
    setShowModal(false);
    setVacantLandToDelete(null);
    setVacantLandIndexToDelete(null);
  };

  const handleConfirmDeleteVacantLand = async () => {
    if (!vacantLandToDelete || vacantLandIndexToDelete === null) return;
    const isDeleted = await handleRemoveVacantLand(
      vacantLandToDelete,
      vacantLandIndexToDelete,
    );
    if (isDeleted) {
      closeDeleteVacantLandModal();
    }
  };

  // Update vacant land field
  const handleUpdateVacantLand = (field, value) => {
    const normalizedValue =
      field === "reta_contact_about_unit" &&
      value !== "" &&
      value !== null &&
      value !== undefined
        ? Number(value)
        : value;

    const isChangingType = field === "exploitation_type_id";
    const isNotOther = isChangingType && String(value) !== "7";

    setCurrentVacantLand((prev) => {
      if (isNotOther) {
        return {
          ...prev,
          [field]: normalizedValue,
          exploitation_type_other: "",
        };
      }

      return {
        ...prev,
        [field]: normalizedValue,
      };
    });

    if (vacantLandErrors[field]) {
      setVacantLandErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const handleEditVacantLand = (vacantLandToBeEdited, index) => {
    if (!vacantLandToBeEdited) return;
    setEditingVacantLandIndex(index);
    setCurrentVacantLand({
      id: vacantLandToBeEdited.id || null,
      used_land_area: vacantLandToBeEdited.used_land_area || "",
      exploitation_type_id: vacantLandToBeEdited.exploitation_type_id || "",
      exploitation_type_other:
        vacantLandToBeEdited.exploitation_type_other || "",
      reta_contact_about_unit:
        vacantLandToBeEdited.reta_contact_about_unit || "",
      account_code: vacantLandToBeEdited.account_code || "",
      market_value: vacantLandToBeEdited.market_value || "",
    });
    setVacantLandErrors({
      used_land_area: "",
      exploitation_type_id: "",
      exploitation_type_other: "",
      reta_contact_about_unit: "",
      account_code: "",
    });
  };

  const handleCancelVacantLand = () => {
    setEditingVacantLandIndex(null);
    setCurrentVacantLand({
      used_land_area: "",
      exploitation_type_id: "",
      exploitation_type_other: "",
      reta_contact_about_unit: "",
      account_code: "",
      market_value: "",
    });
    setVacantLandErrors({
      used_land_area: "",
      exploitation_type_id: "",
      exploitation_type_other: "",
      reta_contact_about_unit: "",
      account_code: "",
    });
    setAddVacantLandErrorMessage("");
  };

  const canEditUnit =
    !declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode;

  const showOtherExploitationColumn =
    Array.isArray(declarationRequest?.unit?.vacantLands) &&
    declarationRequest.unit.vacantLands.some(
      (vl) => String(vl?.exploitation_type_id) === "7",
    );

  const attachedEssentialDocuments = [
    {
      key: "land_ownership_legal_document",
      label: "مرفق سند ملكية الأرض",
      file: declarationRequest?.unit?.land_ownership_legal_document,
    },
    {
      key: "land_lease_agreement",
      label: "مرفق سند عقد الإيجار",
      file: declarationRequest?.unit?.land_lease_agreement,
    },
  ].filter((document) => document.file !== null && document.file !== undefined);

  useEffect(() => {
    if (!hasUnitAddress) {
      setIsAddVacantButtonDisabled(true);
    } else {
      setIsAddVacantButtonDisabled(false);
    }
  }, [hasUnitAddress]);

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={closeDeleteVacantLandModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>هل أنت متأكد من حذف هذا الإستغلال</h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleConfirmDeleteVacantLand}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={closeDeleteVacantLandModal}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>

      {fields.map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}

      {/* Land Documents Upload */}
      {!declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode && (
        <>
          <div className="row ">
            <div className="col-md-4">
              <InputElement
                fileInputRef={landOwnershipLegalDocument}
                mb4="mb-4"
                key={`agency-${fileInputKeys.land_ownership_legal_document}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="land_ownership_legal_document"
                labelClassName={`${stylesRequestData["form-label"]} form-label  `}
                labelText="سند ملكية الأرض"
                inputType="file"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="land_ownership_legal_document"
                name="land_ownership_legal_document"
                fileName={
                  declarationRequest?.unit?.land_ownership_legal_document
                    ?.original_file_name || "إرفاق ملف"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["land_ownership_legal_document"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.land_ownership_legal_document !==
                  null
                }
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
                deleteFunction={() => {
                  handleChangeDeclerationUnit(
                    "",
                    "",
                    "land_ownership_legal_document",
                    null,
                  );
                  if (landOwnershipLegalDocument?.current) {
                    landOwnershipLegalDocument.current.value = null;
                  }
                }}
              />
            </div>
            <div className="col-md-4">
              <InputElement
                fileInputRef={leaseContractFileInputRef}
                mb4="mb-4"
                key={`agency-${fileInputKeys.land_lease_agreement}`}
                inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                labelHtmlFor="land_lease_agreement"
                labelClassName={` ${stylesRequestData["form-label"]} form-label  `}
                labelText="سند الإيجار"
                inputType="file"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="land_lease_agreement"
                name="land_lease_agreement"
                fileName={
                  declarationRequest?.unit?.land_lease_agreement
                    ?.original_file_name || "إرفاق ملف"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                icon="fa-solid fa-cloud-arrow-up"
                accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                pText={fileErrors["land_lease_agreement"]}
                hideErrorMessage
                onChange={handleChangeUnitFile}
                customServerInput={
                  declarationRequest?.unit?.land_lease_agreement !== null
                }
                disabled={
                  declarationRequest?.viewMode ||
                  declarationRequest?.isUnitViewMode
                }
                deleteFunction={() => {
                  handleChangeDeclerationUnit(
                    "",
                    "",
                    "land_lease_agreement",
                    null,
                  );
                  if (leaseContractFileInputRef?.current) {
                    leaseContractFileInputRef.current.value = null;
                  }
                }}
              />
            </div>
          </div>
        </>
      )}

      <div className="row ">
        <div className="col-12 d-flex justify-content-between align-items-center mt-3">
          <h4 className={`${stylesRequestData["box-title"]} box-title `}>
            وصف الإستغلال
          </h4>
        </div>
      </div>

      {/* Vacant Lands Exploitation Section */}
      {canEditUnit && (
        <>
          <div className="col-lg-4 col-sm-6">
            <InputElement
              mb4="mb-4"
              labelHtmlFor="used_land_area"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="المساحة المستغلة "
              inputType="text"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="used_land_area"
              name="used_land_area"
              allowedPattern={/^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/}
              placeholder="ادخل المساحة المستغلة.."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              value={currentVacantLand.used_land_area || ""}
              onChange={(pc, c, key, value) => {
                handleUpdateVacantLand("used_land_area", value);
              }}
              pText={vacantLandErrors?.used_land_area}
              disabled={!canEditUnit}
            />
          </div>
          <div className="col-lg-4 col-sm-6">
            <SearchSelectElement
              mb4="mb-4"
              labelHtmlFor="exploitation_type_id"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="نوع الإستغلال "
              selectClassName={`${stylesRequestData["form-select"]} form-select`}
              selectID="exploitation_type_id"
              inputId="exploitation_type_id_input"
              name="exploitation_type_id"
              options={generateOptions(exploitationTypes)}
              default="اختار نوع الاستغلال.."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              pText={vacantLandErrors?.exploitation_type_id}
              value={currentVacantLand.exploitation_type_id}
              onChange={(pc, c, key, value) => {
                handleUpdateVacantLand("exploitation_type_id", value);
              }}
              isClearable={true}
              disabled={!canEditUnit}
            />
          </div>

          {/* Other Exploitation Type */}
          {parseInt(currentVacantLand.exploitation_type_id) === 7 && (
            <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="exploitation_type_other"
                labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                labelText="نوع الإستغلال الآخر"
                inputType="text"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="exploitation_type_other"
                name="exploitation_type_other"
                maxLength="100"
                allowedPattern={
                  /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_.\\/,\s]{0,100}$/
                }
                placeholder="ادخل نوع الاستغلال الآخر"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={currentVacantLand.exploitation_type_other || ""}
                onChange={(pc, c, key, value) => {
                  handleUpdateVacantLand("exploitation_type_other", value);
                }}
                pText={vacantLandErrors?.exploitation_type_other}
                disabled={!canEditUnit}
              />
            </div>
          )}

          <div className="col-lg-4 col-sm-6">
            <SearchSelectElement
              mb4="mb-4"
              labelHtmlFor="reta_contact_about_unit"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="هل تم التواصل مع الضرائب العقارية بخصوص الوحدة محل الإقرار سابقا؟"
              selectClassName={`${stylesRequestData["form-select"]} form-select`}
              selectID="reta_contact_about_unit"
              inputId="reta_contact_about_unit_input"
              name="reta_contact_about_unit"
              options={generateOptions(doYouWantExtraAttachments)}
              default="اختر.."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              pText={vacantLandErrors?.reta_contact_about_unit}
              value={currentVacantLand.reta_contact_about_unit ?? ""}
              onChange={(pc, c, key, value) => {
                handleUpdateVacantLand("reta_contact_about_unit", value);
              }}
              isClearable={true}
              disabled={!canEditUnit}
            />
          </div>

          {/* Account Code (if answered yes) */}
          {Number(currentVacantLand.reta_contact_about_unit) === 1 && (
            <div className="col-lg-4 col-sm-6">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="account_code"
                labelClassName={` form-label ${stylesRequestData["form-label"]}`}
                labelText="كود حساب الوحدة "
                inputType="text"
                inputClassName={`${stylesRequestData["form-control"]} form-control`}
                inputID="account_code"
                name="account_code"
                maxLength="14"
                allowedPattern={/^\d{0,14}$/}
                placeholder="ادخل كود حساب الوحدة.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={currentVacantLand.account_code || ""}
                onChange={(pc, c, key, value) => {
                  handleUpdateVacantLand("account_code", value);
                }}
                pText={vacantLandErrors?.account_code}
                disabled={!canEditUnit}
              />
            </div>
          )}

          <div className="col-lg-4 col-sm-6">
            <InputElement
              mb4="mb-4"
              labelHtmlFor="market_value"
              labelClassName={`form-label ${stylesRequestData["form-label"]}`}
              labelText="القيمة السوقية"
              inputType="text"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="market_value"
              name="market_value"
              allowedPattern={/^(?!0+(?:\.0{0,2})?$)\d{0,19}(?:\.\d{0,2})?$/}
              placeholder="ادخل القيمة السوقية.."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              value={currentVacantLand.market_value || ""}
              onChange={(pc, c, key, value) => {
                handleUpdateVacantLand("market_value", value);
              }}
              pText={vacantLandErrors?.market_value}
              disabled={!canEditUnit}
            />
          </div>

          {/* Add Utilization Button */}
          <div className="d-flex flex-lg-row flex-column gap-3 align-items-start mb-2 mt-2">
            <div className="d-flex flex-column">
              <div className="d-flex flex-lg-row gap-3">
                <button
                  type="button"
                  onClick={handleAddVacantLand}
                  className={`${isAddVacantButtonDisabled ? stylesRequestData["btn-request-disabled"] : stylesRequestData["btn-request"]}`}
                >
                  {editingVacantLandIndex !== null ? "حفظ" : "إضافة استغلال"}
                </button>

                {editingVacantLandIndex !== null && (
                  <div>
                    <button
                      type="button"
                      className={`${stylesRequestData["btn-cancel"]}`}
                      onClick={handleCancelVacantLand}
                    >
                      إلغاء
                    </button>
                  </div>
                )}
              </div>

              {
                <p className="text-primary mb-2 mt-2 me-2 fw-bolder">
                  يجب أن لا تكون مساحة الجزء المستغل أكبر من المساحة الكلية
                  للأرض
                </p>
              }
            </div>
          </div>
        </>
      )}

      {/* Display Added Vacant Lands */}
      {Array.isArray(declarationRequest?.unit?.vacantLands) &&
        declarationRequest?.unit?.vacantLands.length > 0 && (
          <div className="row mb-5">
            <div className="col-12">
              {/* <h6 className={`${stylesRequestData["box-title"]} box-title mb-4 mt-3`}>وصف الإستغلال</h6> */}
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>المساحة المستغلة</th>
                      <th>نوع الاستغلال</th>
                      {showOtherExploitationColumn && (
                        <th>نوع الإستغلال الآخر</th>
                      )}
                      {/* <th>
                        هل تم التواصل مع الضرائب العقارية بخصوص الوحدة سابقا؟
                      </th> */}
                      <th> كود حساب الوحدة</th>
                      <th>القيمة السوقية</th>

                      {!declarationRequest?.viewMode &&
                        !declarationRequest?.isUnitViewMode && (
                          <>
                            {" "}
                            <th> </th>
                          </>
                        )}
                    </tr>
                  </thead>
                  <tbody>
                    {declarationRequest?.unit?.vacantLands?.map((vl, index) => (
                      <tr key={vl.id ?? `vacant-land-${index}`}>
                        <td>{vl.used_land_area}</td>
                        <td>
                          {resolveExploitationLabel(vl.exploitation_type_id)}
                        </td>
                        {showOtherExploitationColumn && (
                          <td>
                            {String(vl.exploitation_type_id) === "7"
                              ? vl.exploitation_type_other || "-"
                              : "-"}
                          </td>
                        )}
                        {/* <td>
                          {Number(vl.reta_contact_about_unit) === 1
                            ? "نعم"
                            : "لا"}
                        </td> */}
                        <td>{vl.account_code || "-"}</td>
                        <td>{vl.market_value || "-"}</td>
                        {/* actions */}
                        <td data-label="إجراءات">
                          <div
                            className={`d-flex ${stylesRequestData["action-buttons-small-screen"]}`}
                          >
                            <div
                              className={`${stylesRequestData["action-buttons"]}`}
                            >
                              {canEditUnit && (
                                <>
                                  <button
                                    type="button"
                                    className={`${stylesRequestData["btn-edit"]}`}
                                    onClick={() =>
                                      handleEditVacantLand(vl, index)
                                    }
                                    title="تعديل الوحدة"
                                    disabled={editingVacantLandIndex !== null}
                                  >
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </button>

                                  {declarationRequest?.unit?.vacantLands
                                    ?.length > 1 && (
                                    <button
                                      type="button"
                                      className={`${stylesRequestData["btn-delete-icon"]}`}
                                      onClick={() =>
                                        openDeleteVacantLandModal(vl, index)
                                      }
                                      title="حذف المبني"
                                      disabled={editingVacantLandIndex !== null}
                                    >
                                      <i className="fa-solid fa-trash-can"></i>
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

      {(declarationRequest?.viewMode || declarationRequest?.isUnitViewMode) &&
        attachedEssentialDocuments.length > 0 && (
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              قائمة المستندات الأساسية
            </h4>
            <div className="row">
              {attachedEssentialDocuments.map((document) => (
                <div className="col-md-4" key={document.key}>
                  <label
                    htmlFor={document.key}
                    className={`${stylesRequestData["form-label"]} form-label`}
                  >
                    {document.label}
                  </label>
                  <div className="col-2-4 d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-3 px-2 align-items-center mb-3">
                    <p
                      className="mb-0 file-name fs-6"
                      title={document.file?.original_file_name}
                    >
                      {document.file?.original_file_name}
                    </p>
                    <div className="d-flex align-items-center">
                      <span
                        type="button"
                        onClick={() =>
                          handlePreviewFile(document.file?.full_url)
                        }
                        className="text-danger border-0"
                      >
                        <i
                          className="fa-regular fa-eye fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                      <span
                        type="button"
                        onClick={() => DownloadFile(document.file?.full_url)}
                        className="text-danger border-0"
                      >
                        <i
                          className="fa-solid fa-cloud-arrow-down fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </>
  );
};

export default VacantLandForm;
